import { render, staticRenderFns } from "./service.html?vue&type=template&id=cd98c642&scoped=true&"
import script from "./service.js?vue&type=script&lang=js&"
export * from "./service.js?vue&type=script&lang=js&"
import style0 from "./service.less?vue&type=style&index=0&id=cd98c642&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd98c642",
  null
  
)

export default component.exports